var u = (i, p, s) => new Promise((n, o) => {
  var d = (e) => {
    try {
      t(s.next(e));
    } catch (a) {
      o(a);
    }
  }, m = (e) => {
    try {
      t(s.throw(e));
    } catch (a) {
      o(a);
    }
  }, t = (e) => e.done ? n(e.value) : Promise.resolve(e.value).then(d, m);
  t((s = s.apply(i, p)).next());
});
import "../../node_modules/.pnpm/vue@3.5.18_typescript@5.2.2/node_modules/vue/dist/vue.runtime.esm-bundler.js";
import v from "./indexTableItem.vue.js";
import { defineComponent as C, useTemplateRef as b, openBlock as h, createBlock as y, withCtx as c, createVNode as f } from "../../node_modules/.pnpm/@vue_runtime-core@3.5.18/node_modules/@vue/runtime-core/dist/runtime-core.esm-bundler.js";
import { useShadowRoot as _ } from "../../node_modules/.pnpm/@vue_runtime-dom@3.5.18/node_modules/@vue/runtime-dom/dist/runtime-dom.esm-bundler.js";
import { unref as r } from "../../node_modules/.pnpm/@vue_reactivity@3.5.18/node_modules/@vue/reactivity/dist/reactivity.esm-bundler.js";
import w from "../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/locales/common/zhCN.js";
import x from "../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/locales/date/zhCN.js";
import B from "../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/config-provider/src/ConfigProvider.js";
import I from "../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/message/src/MessageProvider.js";
const V = /* @__PURE__ */ C({
  __name: "indexTable.ce",
  props: {
    businessId: { default: "", type: null },
    isShowAddApprovalButton: { type: Boolean, default: !1 },
    isAll: { type: Boolean, default: !1 },
    status: { default: "", type: null }
  },
  emits: ["submit", "cancal", "addApproval"],
  setup(i, { expose: p, emit: s }) {
    const n = b("indexTableItemRefs"), o = i, d = _(), m = {
      common: {
        primaryColor: "#FC9153",
        primaryColorHover: "#FC9153",
        primaryColorPressed: "#FC9153",
        primaryColorSuppl: "#FC9153"
      }
    }, t = s, e = (l) => {
      t("submit", l);
    }, a = () => {
      t("cancal");
    }, A = () => {
      t("addApproval");
    };
    return p({ init: () => u(this, null, function* () {
      var l;
      yield (l = n.value) == null ? void 0 : l.init();
    }) }), (l, R) => (h(), y(r(B), {
      locale: r(w),
      "date-locale": r(x),
      "theme-overrides": m,
      "style-mount-target": r(d)
    }, {
      default: c(() => [
        f(r(I), null, {
          default: c(() => [
            f(v, {
              ref_key: "indexTableItemRefs",
              ref: n,
              onSubmit: e,
              onCancal: a,
              onAddApproval: A,
              businessId: o.businessId,
              isAll: o.isAll,
              isShowAddApprovalButton: o.isShowAddApprovalButton,
              status: o.status
            }, null, 8, ["businessId", "isAll", "isShowAddApprovalButton", "status"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["locale", "date-locale", "style-mount-target"]));
  }
});
export {
  V as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/components/approval-table/indexTable.ce.vue2.js
// module id = 1173
// module chunks = 41